import { createContext } from "react";
const IsAuth=createContext();
export default IsAuth;